import React from 'react';
import SettlementIntelligenceDashboard from '../components/analytics/SettlementIntelligenceDashboard';
import AppLayout from '../components/AppLayout';

export default function SettlementIntelligencePage() {
  return (
    <AppLayout>
      <SettlementIntelligenceDashboard />
    </AppLayout>
  );
}
